import React, { useState, useRef, useEffect } from "react";
import PageWrapper from "./components/PageWrapper";
import { useFormCtx } from "./FormContext";

import * as Const from "./_Const";

import Navbar from "./components/Navbar";
import Button from "./components/Button";

function PageErrorLog() {
  const { logText, sendLogToApi } = useFormCtx();
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.scrollTop = textareaRef.current.scrollHeight;
    }
  }, [logText]);

  return (
    <>
      <Navbar />
      <div className="mt-4 flex flex-col space-y-4 mx-6">
        <textarea className="roundeda bg-disabled" ref={textareaRef} value={logText} rows={24} cols={50} readOnly />
        <div className="flex justify-center">
          <Button type="primary" title="Odeslat LOG do API" showIcon={false} onClick={() => sendLogToApi()} className="h-20" />
        </div>
      </div>
    </>
  );
}

export default PageErrorLog;
